import React from 'react';

import {
  ContainerProps,
  ContainerStyled,
  ContentWrapperStyled,
  SlotStyled,
} from './StaticBanner.styled';

type Props = {
  children: React.ReactNode;
  slots?: Partial<{
    before: React.ReactNode;
    after: React.ReactNode;
  }>;
  testId?: string;
} & Partial<ContainerProps>;

export default function StaticBanner({
  children,
  slots,
  appearance = 'info',
  testId = 'static-banner',
}: Props): JSX.Element {
  const getTestId = (element: string) => {
    return `${testId}-${element}`;
  };

  return (
    <ContainerStyled data-testid={testId} appearance={appearance}>
      {slots?.before && (
        <SlotStyled data-testid={getTestId('slot-before')}>
          {slots.before}
        </SlotStyled>
      )}
      <ContentWrapperStyled data-testid={getTestId('content')}>
        {children}
      </ContentWrapperStyled>
      {slots?.after && (
        <SlotStyled data-testid={getTestId('slot-after')}>
          {slots.after}
        </SlotStyled>
      )}
    </ContainerStyled>
  );
}
